import { BORDER_COLORS as BC, SURFACE_COLORS as SC, TEXT_COLORS as TC } from '@constants/colors.ts';
import type { CheckboxProps } from 'antd';
import { Checkbox } from 'antd';
import styled from 'styled-components';

import {
    getCheckboxAfterStyle,
    getCheckboxBackground,
    getCheckboxHoverBackground,
    getCheckboxTickBorderColor,
    getHoveredBorderColor,
    getIndeterminateBorderColor,
    getIndeterminateTickColor,
} from './utils.ts';

type Props = CheckboxProps & {
    $hasError: boolean;
    $isSmallSize: boolean;
    $isReadOnly: boolean;
};

const StyledCheckbox = styled((props: Props) => <Checkbox {...props} />)`
    .ant-checkbox {
        .ant-checkbox-inner {
            border-width: ${({ $isSmallSize: isSmallSize }) => (isSmallSize ? '1px' : '2px')};
            border-color: ${BC.default};
        }
    }
    .ant-checkbox:hover {
        .ant-checkbox-inner {
            border-color: ${({ $hasError: hasError, $isReadOnly: isReadOnly }) =>
                getHoveredBorderColor({ hasError, isReadOnly })} !important;
            background: ${({ checked, $hasError: hasError, indeterminate, $isReadOnly: isReadOnly }) =>
                getCheckboxHoverBackground({ checked, hasError, indeterminate, isReadOnly })} !important;
        }
    }
    .ant-checkbox-input:focus-visible + .ant-checkbox-inner {
        outline: 3px solid ${SC.action};
    }
    .ant-checkbox-checked {
        .ant-checkbox-inner {
            background: ${SC.action};
            border-color: ${BC.action};
        }
        .ant-checkbox-inner::after {
            border-color: ${({ $hasError: hasError, $isReadOnly: isReadOnly }) =>
                getCheckboxTickBorderColor({ hasError, isReadOnly })};
        }
    }
    .ant-checkbox-inner {
        width: ${({ $isSmallSize: isSmallSize }) => (isSmallSize ? 18 : 24)}px;
        height: ${({ $isSmallSize: isSmallSize }) => (isSmallSize ? 18 : 24)}px;
    }
    .ant-checkbox-inner::after {
        ${({ $isSmallSize: isSmallSize, indeterminate }) => getCheckboxAfterStyle(isSmallSize, indeterminate)}
    }
    .ant-checkbox-disabled {
        .ant-checkbox-inner {
            background: ${SC.disabled};
            border-color: ${BC.disabled};
        }
        .ant-checkbox-inner::after {
            border-color: ${TC.disabled};
        }
    }
    &.has-error {
        .ant-checkbox-inner {
            background: ${SC.error};
            border-color: ${BC.error};
        }
    }
    .ant-checkbox-indeterminate {
        .ant-checkbox-inner {
            background: ${({ disabled, $hasError: hasError, $isReadOnly: isReadOnly }) =>
                getCheckboxBackground({ disabled, hasError, isReadOnly })} !important;
            border-color: ${({ disabled, $hasError: hasError, $isReadOnly: isReadOnly }) =>
                getIndeterminateBorderColor({ disabled, hasError, isReadOnly })} !important;
        }
        .ant-checkbox-inner::after {
            background-color: ${({ disabled, $hasError: hasError, $isReadOnly: isReadOnly }) =>
                getIndeterminateTickColor({ disabled, hasError, isReadOnly })};
        }
    }
    &.read-only {
        .ant-checkbox-inner {
            background: ${SC.white};
            border-color: ${BC.default};
        }
    }
`;

export default StyledCheckbox;
